export function sleep (ms, value = undefined) {
    return new Promise(resolve => setTimeout(() => resolve(value), ms))
}

export function promiseTimeout (promise, ms, value) {
    return Promise.race([promise, sleep(ms, value)])
}

// Transforms json array to csv to reduce response size,
// by stripping out repeated keys.
export function serializeEmotes (data) {
    const emotes = data.emotes.map(e => {
        const { id, imageType, code } = e
        return `${id},${imageType},${code}`
    })

    const csvData = { ...data, emotes }
    return JSON.stringify(csvData)
}

// TODO: Returning pure CSV, and replacing the file extension with an enum val,
// reduces payload size by 10%. A future TODO, if egress, bandwidth becomes a
// problem, perf wise or $$$ wise.
//
// export function serializeEmotes (data) {
//     const emotes = data.emotes.map(e => {
//         const { id, imageType, code } = e
//         return `${id},0,${code}`
//     })

//     const csvData = emotes.join('\n')
//     return csvData
// }

export function deserializeEmotes (jsonData) {
    const data = JSON.parse(jsonData)
    data.emotes = data.emotes.map(e => {
        const [id, imageType, code] = e.split(',')
        return { id, imageType, code }
    })
    return data
}

// https://stackoverflow.com/a/1077097/2498782
const validDomIdChars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'

export function createRandomString (len = 20, chars = validDomIdChars) {
    let result = ''
    for (var i = len; i > 0; --i) {
        result += chars[Math.floor(Math.random() * chars.length)]
    }
    return result
}

export const FONT_ORIGIN = 'https://fonts.googleapis.com'
export const DEFAULT_FONT_URL = `${FONT_ORIGIN}/css2?family=Roboto&display=swap`
// Prevent any potential security vulnerabilities by validating the origin.
export function isValidFontUrl (url) {
    let urlObj
    try {
        urlObj = new URL(url)
    } catch (err) {
        return false
    }

    const isCorrectOrigin = urlObj.origin === FONT_ORIGIN
    return isCorrectOrigin
}

export const IMG_FILE_EXT_REGEX = /\.(gif|jpe?g|tiff?|png|webp|bmp)$/i
